import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';
import { baseButtonStyles } from 'components/common.styles';

export const LinkButtonStyled = styled(Link)`
  ${baseButtonStyles}
  text-decoration: none;
  line-height: normal;
`;
